(function() {
  const gallerySelector = '.facest-filters-section--editorial [data-product-card-gallery]';

  function updateDots(gallery) {
    const link = gallery.closest('.m-product-card__link');
    const dots = link ? Array.from(link.querySelectorAll('.m-product-card__image-dot')) : [];
    const activeIndex = getActiveIndex(gallery, dots.length);

    if (dots.length === 0) return activeIndex;

    dots.forEach((dot, index) => {
      dot.classList.toggle('is-active', index === activeIndex);
    });

    return activeIndex;
  }

  function getActiveIndex(gallery, maxItems) {
    const slideWidth = gallery.clientWidth || 1;
    const maxIndex = Math.max(0, (maxItems || gallery.children.length) - 1);
    return Math.min(maxIndex, Math.max(0, Math.round(gallery.scrollLeft / slideWidth)));
  }

  function updateArrows(gallery) {
    const media = gallery.closest('.m-product-card__media');
    const prevButton = media && media.querySelector('[data-product-card-gallery-prev]');
    const nextButton = media && media.querySelector('[data-product-card-gallery-next]');
    if (!prevButton || !nextButton) return;

    const activeIndex = getActiveIndex(gallery);
    const maxIndex = Math.max(0, gallery.children.length - 1);
    prevButton.disabled = activeIndex <= 0;
    nextButton.disabled = activeIndex >= maxIndex;
  }

  function updateGalleryState(gallery) {
    updateDots(gallery);
    updateArrows(gallery);
  }

  function initGallery(gallery) {
    if (gallery.dataset.galleryReady === 'true') return;
    gallery.dataset.galleryReady = 'true';

    const link = gallery.closest('.m-product-card__link');
    const media = gallery.closest('.m-product-card__media');
    const prevButton = media && media.querySelector('[data-product-card-gallery-prev]');
    const nextButton = media && media.querySelector('[data-product-card-gallery-next]');
    let rafId = null;
    let isMouseDown = false;
    let startX = 0;
    let startY = 0;
    let startScrollLeft = 0;
    let suppressClick = false;

    function scheduleDotUpdate() {
      if (rafId) window.cancelAnimationFrame(rafId);
      rafId = window.requestAnimationFrame(() => updateGalleryState(gallery));
    }

    function scrollToIndex(index) {
      const maxIndex = Math.max(0, gallery.children.length - 1);
      const nextIndex = Math.min(maxIndex, Math.max(0, index));
      gallery.scrollTo({
        left: nextIndex * gallery.clientWidth,
        behavior: 'smooth'
      });
      window.setTimeout(scheduleDotUpdate, 220);
    }

    gallery.addEventListener('scroll', scheduleDotUpdate, { passive: true });

    gallery.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      isMouseDown = true;
      startX = event.clientX;
      startY = event.clientY;
      startScrollLeft = gallery.scrollLeft;
      gallery.classList.add('is-dragging');
      gallery.setPointerCapture?.(event.pointerId);
    });

    gallery.addEventListener('pointermove', (event) => {
      if (!isMouseDown) return;

      const deltaX = event.clientX - startX;
      const deltaY = event.clientY - startY;
      if (Math.abs(deltaX) < 4 || Math.abs(deltaY) > Math.abs(deltaX)) return;

      suppressClick = true;
      gallery.scrollLeft = startScrollLeft - deltaX;
      scheduleDotUpdate();
      event.preventDefault();
    });

    function stopMouseDrag(event) {
      if (!isMouseDown) return;
      isMouseDown = false;
      gallery.classList.remove('is-dragging');
      gallery.releasePointerCapture?.(event.pointerId);
      window.setTimeout(() => {
        suppressClick = false;
      }, 120);
    }

    gallery.addEventListener('pointerup', stopMouseDrag);
    gallery.addEventListener('pointercancel', stopMouseDrag);
    gallery.addEventListener(
      'touchstart',
      (event) => {
        const touch = event.touches[0];
        if (!touch) return;
        startX = touch.clientX;
        startY = touch.clientY;
      },
      { passive: true }
    );
    gallery.addEventListener(
      'touchmove',
      (event) => {
        const touch = event.touches[0];
        if (!touch) return;

        const deltaX = touch.clientX - startX;
        const deltaY = touch.clientY - startY;
        if (Math.abs(deltaX) > 8 && Math.abs(deltaX) > Math.abs(deltaY)) {
          suppressClick = true;
          window.setTimeout(() => {
            suppressClick = false;
          }, 450);
        }
      },
      { passive: true }
    );
    gallery.addEventListener('collection:gallery-image-updated', () => {
      scrollToIndex(0);
      scheduleDotUpdate();
    });

    if (prevButton && nextButton) {
      prevButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        scrollToIndex(getActiveIndex(gallery) - 1);
      });

      nextButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        scrollToIndex(getActiveIndex(gallery) + 1);
      });
    }

    if (link) {
      link.addEventListener(
        'click',
        (event) => {
          if (!suppressClick) return;
          event.preventDefault();
          event.stopPropagation();
        },
        true
      );
    }

    updateGalleryState(gallery);
  }

  function initAll(root) {
    root.querySelectorAll(gallerySelector).forEach(initGallery);
  }

  function observeCollectionGrid() {
    const productContainer = document.querySelector('.facest-filters-section--editorial [data-product-container]');
    if (!productContainer) return;

    const observer = new MutationObserver((mutations) => {
      if (!mutations.some((mutation) => mutation.addedNodes.length > 0)) return;
      initAll(productContainer);
    });

    observer.observe(productContainer, { childList: true });
  }

  function init() {
    initAll(document);
    observeCollectionGrid();
    window.wcmmgEvents?.subscribe?.('ON_PRODUCT_LIST_UPDATED', () => initAll(document));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
